module.exports = __webpack_public_path__ + "static/img/leaflet.1584b99a.jpg";